
/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const TagsBlock = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'TagsBlock',
    title: {
      en: '',
    },
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const [title, setTitle] = useState({ 'en': '' });

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          title: currentTitle,
        } = component;

        setState(component);
        setTitle(currentTitle);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      title: { ...title },
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    title,
  ]);

  const titleChange = (e) => {
    title[activeLanguage] = e.target.value
    setTitle({ ...title });
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex">
        <div className="w-full">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          >
            Title
          </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            type="text"
            onChange={titleChange}
            value={title[activeLanguage] || ''}
          />
        </div>
      </div>
      {/* End */}

    </div>
  );
};

TagsBlock.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TagsBlock.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TagsBlock;
